import { useState, useEffect } from 'react'
// redux
import { useSelector } from 'react-redux'
// hooks
import useUserActions from './useUserActions'
import useUIActions from './useUIActions'
import useTodayQueries from './useTodayQueries'
// utils
import normalizeText from 'utils/normalizeText'
// services
// import TodayServices from 'services/today' // Comentado - se usa en useTodayQueries
// queries
import { useContentfulForToday } from './contentful'
// components
import Modal from 'components/atoms/modal/modal'
import NPSSlider from 'components/molecules/NPS-slider/NPS-slider'

export default function useForToday() {
	// redux
	const {
		session: { community, userId },
		elementsUI: {
			showOverlay: { open }
		}
	} = useSelector(state => state)

	// queries
	const { headForToday } = useContentfulForToday()
	const { headButtonsText } = headForToday || false

	// hook
	const { setInfoUser } = useUserActions()
	const { handleShowModal } = useUIActions()

	// Cache de Tanstack Query (mantiene la lógica existente)
	const { getCachedTodayData } = useTodayQueries(userId)

	// data
	const [activeSelect, setActiveSelect] = useState({
		active: 0,
		outstanding: 0
	})
	const [toDayState, setToDayState] = useState({
		data: [],
		emtas: false,
		nonPriorizedEmtas: false,
		challengesList: false
	})

	const [forTodayLoading, setForTodayLoading] = useState(false)
	const timeTextInLocal = 'timeTextInLocal'
	const [isTimeText, setIsTimeText] = useState(
		localStorage.getItem(timeTextInLocal)
			? JSON.parse(localStorage.getItem(timeTextInLocal))
			: false
	)

	const dayRange = isTimeText
		? {
				[isTimeText[0]]: {
					init: '00:00:00',
					end: '11:59:00'
				},
				[isTimeText[1]]: {
					init: '12:00:00',
					end: '17:59:00'
				},
				[isTimeText[2]]: {
					init: '18:00:00',
					end: '24:00:00'
				}
		  }
		: false

	// functions
	const validateHourDay = () => {
		const today = new Date()
		const hour = `${today.getHours()}.${
			today.getMinutes() < 10 ? `0${today.getMinutes()}` : today.getMinutes()
		}`
		let positionHour
		if (hour >= 0.0 && hour < 12.0) positionHour = 0
		if (hour > 11.59 && hour < 18.0) positionHour = 1
		if (hour > 17.59 && hour < 23.59) positionHour = 2

		setActiveSelect({
			active: positionHour,
			outstanding: positionHour
		})
	}

	const openNPSModal = () => {
		handleShowModal(
			<Modal>
				<NPSSlider />
			</Modal>
		)
	}

	const setArrayEntries = array => {
		if (array.length === 0) return []
		return [array]
	}

	const sortData = ({
		priorizedEmtas = [],
		nonPriorizedEmtas = [],
		challengesList = [],
		lessonsList = [],
		liveList = [],
		medicinesList = [],
		canAnswerNps = false
	}) => {
		setForTodayLoading(true)
		const dataMapped = {
			liveList: liveList.map(live => ({ ...live, time: live.startDate.split(' ')[1] })) || [],
			challengesList,
			lessonsList,
			medicinesList
		}

		let newData = {}

		Object.entries(dataMapped).forEach(([key, value]) => {
			value
				.map(e => ({ ...e, flag: key }))
				.forEach(e =>
					Object.entries(dayRange).forEach(([jKey, jValue]) => {
						const normalizeKey = normalizeText(jKey)
						if (e.time >= jValue.init && e.time <= jValue.end) {
							newData = {
								...newData,
								[normalizeKey]: newData[normalizeKey]
									? [...newData[normalizeKey], e]
									: setArrayEntries(e)
							}
						}
					})
				)
		})
		setToDayState({
			...toDayState,
			data: newData || [],
			challengesList,
			emtas: priorizedEmtas,
			nonPriorizedEmtas
		})

		canAnswerNps && openNPSModal()
		setForTodayLoading(false)
	}

	// actions
	const handledActiveSelect = value =>
		setActiveSelect({
			...activeSelect,
			active: value
		})

	// calls - AHORA CON CACHE
	const getTodayData = () => {
		setForTodayLoading(true)
		getCachedTodayData()
			.then(res => {
				if (res.status === 200) {
					res.data.community &&
						res.data.community !== community &&
						setInfoUser({ community: res.data.community, companyName: res.data.companyName })
					return sortData({ ...res.data })
				}
			})
			.catch(error => {
				throw new Error(error)
			})
			.finally(() => setForTodayLoading(false))
	}

	useEffect(() => {
		if (!headButtonsText) return
		setIsTimeText(headButtonsText)
		localStorage.setItem(timeTextInLocal, JSON.stringify(headButtonsText))
	}, [headButtonsText])

	useEffect(() => {
		getTodayData()
	}, [open])

	useEffect(() => {
		validateHourDay()
	}, [])

	return {
		// data
		...toDayState,
		activeSelect,
		headButtonsText,
		// loading
		forTodayLoading,
		// actions
		handledActiveSelect,
		openNPSModal
	}
}
